/** Presence of authoritative planning evidence, independent of its amount.
 * An overall approved ceiling or unassigned spending alone is not expected cost. */
export function hasKnownBudgetBasis101(hasEstimate: boolean, rows: ReadonlyArray<{authorizedCents: number|null; quoteCents: number|null; complete?: boolean}>): boolean {
 return hasEstimate || rows.some(row => row.authorizedCents !== null || row.quoteCents !== null || row.complete === true);
}
